<template>
	<div 
		:class="['editable-field', 'editable-text-area', {'active':focused}, {'can-edit':editable}]"
		@click="startEdit">
		<div>
			<div
				:class="['editable-label', {'label-bold': labelBold}]">
				<span>{{label}}</span>
			</div>
			<div
				:class="['editable-value', {'visible': focused}]"
				:style="{visible:focused}">
				<span>{{model}}</span>
			</div>
			<v-textarea
				v-if="editable"
				box single-line
				auto-grow
				ref="control"
				color="primary"
				:class="['body-1', 'editable-input', {'visible': !focused}]"
				v-model="model"
                :maxlength="maxlength"
				@blur="saveEdit"
				@keyup.enter="blurField"
				@keyup.esc="cancelEdit">
			</v-textarea>
		</div>
	</div>
</template>


<script>
	export default {
		name: 'editable-text-area',
		props: {
			editable: {
				type: Boolean,
				required: false,
				default: false
			},
			label: {
				type: String,
				required: false,
				default: ''
			},
			labelBold: {
				type: Boolean,
				required: false,
				default: false
			},
			value: {
				type: [String, Number],
				required: false,
				default: ''
			},
			boundValue: {
				type: [String, Number],
				required: false,
				default: null
			},
			dispatchOnSave: {
				type: Function,
				required: false,
				default: null
			},
			jobUpdateProperty: {
				type: Object,
				required: false,
				default: null
			},
            maxlength: {
                type: Number,
                required: false,
                default: null
            }
		},
		data:() => ({
			model: '',
			focused: false,
			initialValue: ''
		}),
		mounted() {
			this.initialize()
		},
		methods: {
			initialize() {
				if (this.editable && (this.dispatchOnSave !== null && this.boundValue === null)) {
					console.error('editable-textarea needs a boundValue if a dispatchOnSave function is provided.')
				}

				this.initialValue = this.boundValue ? this.boundValue : this.value
				this.model = this.boundValue ? this.boundValue : this.value
				
				if (this.editable) this.$refs.control.$refs['input'].contentEditable = true; // needed to enable edit on v-text-field child input
			},
			blurField() {
				this.$nextTick(() => {
					this.$refs.control.$refs['input'].blur()
				})
			},
			startEdit() { 
				if (this.editable) {
					this.focused = true
					
					this.$nextTick(() => {
						this.$refs.control.$refs['input'].focus()
					})

					this.$emit('start-edit')
				}
			},
			saveEdit() {
				this.focused = false
				if (this.model !== this.initialValue) {

					if(this.jobUpdateProperty) {
						if (this.jobUpdateProperty.hasOwnProperty('key')) {
							this.dispatchOnSave({ 
								[this.jobUpdateProperty['prop']]: this.model[this.jobUpdateProperty['key']]
							})
						} else {
							this.dispatchOnSave({ 
								[this.jobUpdateProperty['prop']]: this.model
							})
						}
					} else {
						this.dispatchOnSave(this.model)
					}

					this.$emit('save-edit', {
						oldValue: this.initialValue,
						newValue: this.model
					})
				}
			},
			cancelEdit() { 
				this.focused = false
				this.model = this.initialValue
				this.$emit('cancel-edit')
			}
		},
		watch: {
			'boundValue': function (newVal) {
				this.initialValue = newVal
				this.model = newVal
			}
		},
	}
</script>